import { gql } from '@apollo/client';

export const GET_WORK_ORDER_TASK = gql`
  query GetWorkOrderTask($id: ID!) {
    workOrderTask(id: $id) {
      id
      version
    }
  }
`;

export const SEARCH_SHIPMENTS = gql`
  query SearchShipmentsByBooking($input: SearchShipmentInput!) {
    searchShipments(input: $input) {
      results {
        id
        version
        legs {
          commercialInvoiceDetail {
            id
            version
            status
          }
        }
      }
    }
  }
`;

export const SEARCH_SHIPMENT_FILING_SESSIONS = gql`
  query SearchShipmentFilingSessionsByShipment(
    $input: SearchShipmentFilingSessionInput!
  ) {
    searchShipmentFilingSessions(input: $input) {
      results {
        id
        version
        phases {
          name
          steps {
            name
            status
          }
        }
      }
    }
  }
`;

export const UPDATE_SHIPMENT_FILING_SESSION = gql`
  mutation UpdateShipmentFilingSession(
    $id: ID!
    $version: Int!
    $input: UpdateShipmentFilingSessionInput!
  ) {
    updateShipmentFilingSession(id: $id, version: $version, input: $input) {
      record {
        id
        version
        phases {
          name
          steps {
            name
            status
          }
        }
      }
    }
  }
`;

export const UPDATE_SHCID = gql`
  mutation UpdateShipmentCommercialInvoiceDetail(
    $id: ID!
    $version: Int!
    $input: UpdateShipmentCommercialInvoiceDetailInput!
  ) {
    updateShipmentCommercialInvoiceDetail(
      id: $id
      version: $version
      input: $input
    ) {
      record {
        id
        version
        status
      }
    }
  }
`;
